import { Helmet } from "react-helmet";

export default function Goftino() {
  return (
    <div>
      <Helmet>
        <script type="text/javascript">
          {`!function(){
            var i="1bsSy3",a=window,d=document;
            function g(){
              var g=d.createElement("script"),
              s="https://www.goftino.com/widget/"+i,
              l=localStorage.getItem("goftino_"+i);
              g.async=!0;
              g.src=l?s+"?o="+l:s;
              d.getElementsByTagName("head")[0].appendChild(g);
            }
            if (d.readyState === "complete") {
              g();
            } else if (a.attachEvent) {
              a.attachEvent("onload", g);
            } else {
              a.addEventListener("load", g, !1);
            }
          }();`}
        </script>
      </Helmet>
    </div>
  );
}
